import { useRequest } from "hooks";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { ID, ResourceResponse, ThunkReturnType } from "types";
import { changeBlacklistedConsumersExportLoading as changeExportLoading } from "../slice";
import type { BlacklistedConsumerResponse } from "../types";
import { deleteConsumersBlacklistThunk, getBlacklistedConsumersThunk, whitelistConsumersThunk } from "../thunks";

const useBlacklistedConsumersActions = () => {
    const getConsumers = useRequest<ThunkReturnType<BlacklistedConsumerResponse>, string>({
        thunk: getBlacklistedConsumersThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetConsumersBlacklist
    });

    const deleteConsumersBlacklist = useRequest<ResourceResponse<ID>, ID>({
        thunk: deleteConsumersBlacklistThunk
    });

    const whitelistConsumers = useRequest<ResourceResponse<ID>, ID>({
        thunk: whitelistConsumersThunk
    });

    return {
        getConsumers,
        downloadCsv,
        deleteConsumersBlacklist,
        whitelistConsumers
    };
};

export default useBlacklistedConsumersActions;
